import * as userRoutines from 'sagas/routines/userRoutines';
import { connect } from 'react-redux';
import NotificationsCreateForm from 'Components/Notifications/Form/NotificationCreateForm';

import { createNotification } from './notificationsRoutines';
import { makeDistinctUsersOrdered, makeSearchableUsers, makeSelectedGroupUsers } from '../../redux/usersSelectors';
const mapState2Props = (state: any) => {
    return {
        activeEvent: state.ui.activeEvent,
        distinctUsers: makeDistinctUsersOrdered(state),
        selectedGroupUsers: makeSelectedGroupUsers(state),
        users: makeSearchableUsers(state),
        users_loading: state.users.users_loading,
    };
};

const mapDispatchToProps = {
    clearExtractedUsers: userRoutines.clearExtractedUsers,
    createNotification,
    fetchUsersFromGroup: userRoutines.fetchUsersFromGroup,
    makeDistinctUsersFromCombined: userRoutines.makeDistinctUsersFromCombined,
};

export default connect(
    mapState2Props,
    mapDispatchToProps,
)(NotificationsCreateForm);
